import * as React from "react";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import { Redirect } from "react-router";
import axios from "../../helpers/axios";
import { isUatEnvironment } from "../../helpers/uatMasking";
import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Button,
  Avatar,
  Menu,
  MenuItem,
  Typography,
  FormControl,
  OutlinedInput,
  TextField,
  CardActions,
  Modal,
  Box,
  Select,
  InputLabel,
  Divider,
  Paper,
  Alert,
  Backdrop,
  CircularProgress,
  Autocomplete,
  Stack,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Radio,
  RadioGroup,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation, WithTranslation } from "react-i18next";
import NeighbourhoodHeader from "./NeighbourhoodHeader";
import {
  DataGrid,
  GridRowParams,
  GridActionsCellItem,
  GridCellParams,
  GridColDef,
} from "@mui/x-data-grid";
import {
  EditOutlined,
  Add,
  Security as SecurityIcon,
  FileCopy as FileCopyIcon,
  KeyboardArrowLeftRounded,
  MoreHorizOutlined,
  CloseOutlined,
  CheckBox,
} from "@mui/icons-material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { formatDate } from "../../helpers/custom";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "65%",
  p: 4,
};

const customTableCellStyle = {
  height: "52px",
  padding: "0px 10px",
};

const customTableHeaderCellStyle = {
  whiteSpace: "nowrap",
};

const getCommunityUserStatus = (user: any) => {
  if (Number(user.flagged) === 1) {
    return "Flagged";
  }

  return Number(user.is_active) === 1 ? "Active" : "Inactive";
};

const getStatusButtonProps = (status: string) => {
  if (status === "Flagged") {
    return {
      color: "inherit" as const,
      sx: { backgroundColor: "#6b7280", color: "#fff" },
    };
  }

  return {
    color: status === "Active" ? ("success" as const) : ("warning" as const),
    sx: {},
  };
};

export interface IProps {
  user: {
    id: number;
    name: string;
    email: string;
    role: string;
    is_active: boolean;
    selectedHierarchies: any[];
    selectedHierarchyIds: any[];
  };
}

export interface IState {
  community_id: any;
  communityHierarchyId: any;
  pageSize: number;
  anchorEl: any;
  community_users: any[];
  showAddCommunityGroup: boolean;
  agentName: string;
  agentMobile: string;
  agentEmail: string;
  agentType: string;
  agentCity: string;
  showBagDistribution: any;
  bagCount: any;
  date: any;
  distributionType: any;
  allotedAgents: any;
  showBatchPickup: any;
  slot: any;
  showBadBagModal: any;
  filterText: string;
  charges: any;
  showUpdateBagPrice: any;
  badBagPrice: any;
  badBagType: any;
  showUpdatePrice: any;
  bulkPrice: any;
  showBagLimit: any;
  bulkBagLimit: any;
  showMessage: any;
  newMessage: any;
  selectedRows: any;
  filterCommGroup: any;
  selectedCommGroup: any;
  showEditGroup: any;
  showLoader: boolean;
  communityGroup: any;
  editGroup: any;
  newGroup: any;
  agents: any;
  pickupDate: any;
  allotedPickupAgents: any;
  bagPrice: any;
  bagPriceUpdateType: any;
  filter: any;
  bagsLeftCount: any;
  userFilter: any;
  communityName: any;
  activeUserCount: any;
  inactiveUserCount: any;
  flaggedUserCount: any;
  userOptions: any;
  overrideMinimumBagsReceived: boolean;
  allRowsSelected: boolean;
  selectedIds: any;
  columnVisibility: any;
  isColumnSelectorOpen: boolean;
  tempColumnVisibility: any;
  actionType: any;
  showModal: boolean;
  selectedUser: any;
  flaggedIsActive: number;
  priorities: any;
}

class NeighbourhoodUsers extends React.Component<
  RouteComponentProps<any> & IProps & WithTranslation,
  IState
> {
  constructor(props: RouteComponentProps & IProps & WithTranslation) {
    super(props);
    this.state = {
      community_id: this.props.match.params.id,
      communityHierarchyId: "",
      pageSize: 20,
      anchorEl: null,
      community_users: [],
      showAddCommunityGroup: false,
      agentName: "",
      agentMobile: "",
      agentEmail: "",
      agentType: "",
      agentCity: "",
      showBagDistribution: false,
      bagCount: 6,
      filterText: "",
      date: null,
      distributionType: "",
      allotedAgents: "",
      showBatchPickup: false,
      slot: "",
      showBadBagModal: false,
      charges: "",
      showUpdateBagPrice: false,
      badBagPrice: "",
      badBagType: "",
      showUpdatePrice: false,
      bulkPrice: "",
      showBagLimit: false,
      bulkBagLimit: "",
      showMessage: false,
      newMessage: "",
      selectedRows: [],
      filterCommGroup: "",
      selectedCommGroup: "",
      showEditGroup: false,
      showLoader: false,
      communityGroup: [],
      editGroup: {},
      newGroup: "",
      agents: [],
      pickupDate: null,
      allotedPickupAgents: "",
      bagPrice: "",
      bagPriceUpdateType: "",
      filter: "",
      bagsLeftCount: "",
      userFilter: null,
      communityName: "",
      activeUserCount: "",
      inactiveUserCount: "",
      flaggedUserCount: "",
      userOptions: [],
      overrideMinimumBagsReceived: true,
      allRowsSelected: false,
      selectedIds: [],
      columnVisibility: {
        Priority: true,
        Price: false,
        Bag: false,
        ExtraPrice: false,
        BadBagCharges: false,
        BagLimit: true,
        ID: true,
        BagsLeft: true,
        Customer: true,
        Phone: true,
        HNo: true,
        Type: true,
        Status: true,
      },
      tempColumnVisibility: {
        Priority: true,
        Price: false,
        Bag: false,
        ExtraPrice: false,
        BadBagCharges: false,
        BagLimit: true,
        ID: true,
        BagsLeft: true,
        Customer: true,
        Phone: true,
        HNo: true,
        Type: true,
        Status: true,
      },

      isColumnSelectorOpen: false,
      actionType: "",
      showModal: false,
      selectedUser: null,
      flaggedIsActive: 1,
      priorities: {} as { [key: number]: string },
    };
  }
  public componentDidMount(): void {
    this.fetchCommunityUsers();
    this.fetchCommunityGroups();
  }

  public fetchCommunityUsers() {
    this.setState({ showLoader: true });
    // console.log("community_user", this.state.community_id);
    let body = {
      hierarchies: this.props.user.selectedHierarchyIds,
    };
    axios
      .get(`getCommunityUsers/${this.state.community_id}`, { params: body })
      .then((response: any) => {
        if (response.data.success) {
          this.setState({ showLoader: false });
          // console.log("response", response.data.data);
          let data = response.data.data;
          // console.log("data", data);
          let communityHierarchyId = data[0]?.info?.hierarchy_id;
          this.setState({ communityName: data[0]?.info?.name });
          let active = 0;
          let inactive = 0;
          let flagged = 0;
          let details: any = data?.map((el: any) => {
            const status = getCommunityUserStatus(el);
            if (status === "Flagged") {
              flagged = flagged + 1;
            } else if (status === "Active") {
              active = active + 1;
            } else {
              inactive = inactive + 1;
            }
            return {
              id: el.id,
              user_id: el.user_id,
              priority: el.priority,
              price: el.price,
              bag_price: el.bag_price,
              extra_bag_price: el.extra_bag_price,
              bad_bag_charges: el.bad_bag_charges,
              bag_limit: el.bag_limit,
              bags_left: el.bags_left?.bags_left,
              customer_name: el.user?.name,
              phone: el.user?.phone,
              hno: el.customer?.location,
              type: el.is_manager == 0 ? "User" : "Manager",
              flagged: Number(el.flagged) === 1,
              status,
            };
          });
          // console.log("detailsData", details);
          this.setState({
            community_users: details,
            activeUserCount: active,
            inactiveUserCount: inactive,
            flaggedUserCount: flagged,
            selectedRows: [],
            selectedIds: [],
            allRowsSelected: false,
            communityHierarchyId,
          }, () => {
            this.fetchAgents();
          });
        } else {
          // console.log("err");
          this.setState({ showLoader: false });
          toast.error(response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          let errors = response.data.errors;
          for (var error in errors) {
            toast.error(errors[error][0], {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ showLoader: false });
        toast.error(error.response.data.msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  }

  public fetchCommunityGroups() {
    let body = {
      hierarchies: this.props.user.selectedHierarchyIds,
      community_id: this.state.community_id,
    };
    axios
      .post("listCommunityGroups", body, {
        headers: { "Content-Type": "application/json" },
      })
      .then((response: any) => {
        if (response.data.success) {
          // console.log("data", response.data.data);
          this.setState({ communityGroup: response.data.data });
        } else {
          this.setState({ showLoader: false });
          toast.error(response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          let errors = response.data.errors;
          for (var error in errors) {
            toast.error(errors[error][0], {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ showLoader: false });
        toast.error(error.response.data.msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  }

  public fetchCustomerLite = (value: any) => {
    // console.log("value");
    this.setState({ showLoader: true });
    let data = {
      filter: value,
      hierarchies: this.props.user.selectedHierarchyIds,
    };
    axios
      .post("customersLite", data, {
        headers: { "content-Type": "application/json" },
      })
      .then((response: any) => {
        if (response.data.success) {
          this.setState({ userOptions: response.data.data, showLoader: false });
        } else {
          this.setState({ showLoader: false });
          toast.error(response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          let errors = response.data.errors;
          for (var error in errors) {
            toast.error(errors[error][0], {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ showLoader: false });
        toast.error(error.response.data.msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  public fetchAgents() {
    if (this.state.communityHierarchyId) {
      this.setState({ showLoader: true });
      let options = { hierarchies: [this.state.communityHierarchyId] };
      axios.get(`allAgentsLite`, { params: options }).then((response: any) => {
        this.setState({ showLoader: false });
        let agents: any = response.data.data;
        this.setState({ agents: agents });
      });
    }
  }

  public render() {
    if (!localStorage.getItem("token")) {
      return <Redirect to="/login" />;
    }
    const { t } = this.props;
    const open = Boolean(this.state.anchorEl);
    const maskedCellSx = isUatEnvironment
      ? {
          filter: "blur(4px)",
          opacity: 0.5,
          userSelect: "none",
        }
      : undefined;
    const renderMaskedCell = (value: React.ReactNode) => (
      <Box component="span" sx={maskedCellSx}>
        {value}
      </Box>
    );

    const handleAddAgent = () => {
      this.setState({ showAddCommunityGroup: false });
      toast.success("Agent added", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    };

    const handleEditCommunityGroup = () => {
      let body = {
        hierarchies: this.props.user.selectedHierarchyIds,
        group_id: this.state.editGroup?.id,
        name: this.state.editGroup?.group_name,
      };
      axios
        .post("editGroup", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({ showEditGroup: false });
            toast.success("Community Group Updated", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCommunityGroups();
          } else {
            this.setState({ showEditGroup: false, showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ showEditGroup: false, showLoader: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleAddCommunityGroup = () => {
      let body = {
        hierarchies: this.props.user.selectedHierarchyIds,
        community_id: this.state.community_id,
        group_name: this.state.newGroup,
      };
      axios
        .post("createGroup", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({ showAddCommunityGroup: false });
            toast.success("Community Group Added", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCommunityGroups();
          } else {
            this.setState({ showAddCommunityGroup: false, showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ showAddCommunityGroup: false, showLoader: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const bagDistribution = () => {
      this.setState({ showLoader: true });
      let body = {
        hierarchies: this.props.user.selectedHierarchyIds,
        agent_id: this.state.allotedAgents,
        bag_count: this.state.bagCount,
        community_id: this.state.community_id,
        distribution_type: this.state.distributionType,
        date: formatDate(this.state.date, "Y-m-d"),
        users: this.state.selectedRows.map((userObj: any) => userObj.user_id),
        overrideMinimumBagsRecevied: this.state.overrideMinimumBagsReceived,
      };
      axios
        .post("bagDistribution", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            // console.log("response", response.data.data);
            this.setState({
              showBagDistribution: false,
              showLoader: false,
              date: "",
              distributionType: "",
              bagCount: 6,
              allotedAgents: "",
            });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            // this.fetchCommunityUsers();
          } else {
            this.setState({
              showBagDistribution: false,
              showLoader: false,
              date: "",
              distributionType: "",
              bagCount: 6,
              allotedAgents: "",
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showBagDistribution: false,
            showLoader: false,
            date: "",
            distributionType: "",
            bagCount: 6,
            allotedAgents: "",
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleNewBatchPickup = () => {
      this.setState({ showLoader: true });
      let body = {
        hierarchies: this.props.user.selectedHierarchyIds,
        agent_id: this.state.allotedPickupAgents,
        community_id: this.state.community_id,
        date: formatDate(this.state.pickupDate, "Y-m-d"),
        slot_id: this.state.slot,
        users: this.state.selectedRows.map((userObj: any) => userObj.user_id),
      };
      axios
        .post("scheduleBatchPickup", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            // console.log("resp", response.data.data);
            this.setState({
              showBatchPickup: false,
              showLoader: false,
              pickupDate: "",
              slot: "",
              allotedPickupAgents: "",
            });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            this.setState({
              showBatchPickup: false,
              showLoader: false,
              pickupDate: "",
              slot: "",
              allotedPickupAgents: "",
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showBatchPickup: false,
            showLoader: false,
            pickupDate: "",
            slot: "",
            allotedPickupAgents: "",
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleBadBagCharges = () => {
      this.setState({ showLoader: true });
      // console.log("selectedRows", this.state.selectedRows);
      let body = {
        hierarchies: this.props.user.selectedHierarchyIds,
        community_user_id: this.state.selectedRows.map(
          (userObj: any) => userObj.id
        ),
        charges: this.state.charges,
      };
      // console.log("body", body);
      axios
        .post("setCustomerBadBagCharges", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            // console.log("resp", response.data.data);
            this.setState({
              showBadBagModal: false,
              charges: "",
              showLoader: false,
            });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCommunityUsers();
          } else {
            // console.log("err");
            this.setState({ showBadBagModal: false, showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ showBadBagModal: false, showLoader: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleCustomerBagPrice = () => {
      this.setState({ showLoader: true });
      let body = {
        hierarchies: this.props.user.selectedHierarchyIds,
        community_user_id: this.state.selectedRows.map(
          (userObj: any) => userObj.id
        ),
        price: this.state.bagPrice,
        type: this.state.bagPriceUpdateType,
      };
      axios
        .post("setCustomerBagPrice", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({
              showUpdateBagPrice: false,
              bagPrice: "",
              bagPriceUpdateType: "",
              showLoader: false,
            });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCommunityUsers();
          } else {
            this.setState({
              showUpdateBagPrice: false,
              bagPrice: "",
              bagPriceUpdateType: "",
              showLoader: false,
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showBadBagModal: false,
            bagPrice: "",
            bagPriceUpdateType: "",
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleCustomerPrice = () => {
      this.setState({ showLoader: true });
      let body = {
        hierarchies: this.props.user.selectedHierarchyIds,
        price: this.state.bulkPrice,
        community_user_id: this.state.selectedRows.map(
          (userObj: any) => userObj.id
        ),
      };
      axios
        .post("setCustomerPrice", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({
              showUpdatePrice: false,
              bulkPrice: "",
              showLoader: false,
            });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCommunityUsers();
          } else {
            this.setState({
              showUpdatePrice: false,
              bulkPrice: "",
              showLoader: false,
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showUpdatePrice: false,
            bulkPrice: "",
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleSendMessage = () => {
      this.setState({ showLoader: true });
      let body = {
        community_id: this.state.community_id,
        hierarchies: this.props.user.selectedHierarchyIds,
        msg: this.state.newMessage,
        users: this.state.selectedRows.map((userObj: any) => userObj.user_id),
      };
      axios
        .post("sendBulkSMS", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({ showLoader: false, showMessage: false });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCommunityUsers();
          } else {
            this.setState({
              showMessage: false,
              newMessage: "",
              showLoader: false,
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showMessage: false,
            newMessage: "",
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleToggleUserType = (row: any) => {
      this.setState({ showLoader: true });
      let body = {
        community_id: this.state.community_id,
        community_user_id: row.id,
        hierarchies: this.props.user.selectedHierarchyIds,
      };
      axios
        .post("communityManagerEdit", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({ showLoader: false });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCommunityUsers();
          } else {
            this.setState({ showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ showLoader: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleToggleUserStatus = (row: any) => {
      this.setState({ showLoader: true });
      let body = {
        community_id: this.state.community_id,
        community_user_id: row.id,
        hierarchies: this.props.user.selectedHierarchyIds,
      };
      axios
        .post("toggleCommunityUserStatus", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({ showLoader: false });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCommunityUsers();
          } else {
            this.setState({ showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ showLoader: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleToggleUserFlaggedStatus = (
      row: any,
      isActive: number = Number(row.is_active) === 1 ? 1 : 0
    ) => {
      this.setState({ showLoader: true });
      const body = {
        community_user_id: row.id,
        is_active: isActive,
      };

      axios
        .post("toggleCommunityUserFlaggedStatus", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCommunityUsers();
          } else {
            this.setState({ showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        })
        .catch((error) => {
          this.setState({ showLoader: false });
          toast.error(
            error.response?.data?.msg || "Community user flagged status cannot be updated",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        });
    };

    const handleDeleteUser = (row: any) => {
      this.setState({ showLoader: true });
      let body = {
        community_id: this.state.community_id,
        user_id: row.user_id,
        hierarchies: this.props.user.selectedHierarchyIds,
      };
      axios
        .post("removeUserFromCommunity", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({ showLoader: false });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCommunityUsers();
          } else {
            this.setState({ showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ showLoader: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleUpdateBagLimit = () => {
      this.setState({ showLoader: true });
      let body = {
        limit: this.state.bulkBagLimit,
        hierarchies: this.props.user.selectedHierarchyIds,
        community_user_id: this.state.selectedRows.map(
          (userObj: any) => userObj.id
        ),
      };
      axios
        .post("setCustomerBagLimit", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            this.setState({ showLoader: false, showBagLimit: false });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCommunityUsers();
          } else {
            this.setState({
              showBagLimit: false,
              bulkBagLimit: "",
              showLoader: false,
            });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            showBagLimit: false,
            bulkBagLimit: "",
            showLoader: false,
          });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleFilterCommunityUsers = () => {
      this.setState({ showLoader: true });
      let body = {
        hierarchies: this.props.user.selectedHierarchyIds,
        filter: this.state.filter,
        bags_left_count: this.state.bagsLeftCount,
        community_id: this.state.community_id,
        group: this.state.filterCommGroup,
      };
      axios
        .post("filterCommunityUsers", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            let data = response.data.data;
            let details: any = data?.map((el: any) => {
              return {
                id: el.id,
                user_id: el.user_id,
                priority: el.priority,
                price: el.price,
                bag_price: el.bag_price,
                extra_bag_price: el.extra_bag_price,
                bad_bag_charges: el.bad_bag_charges,
                bag_limit: el.bag_limit,
                bags_left: el.bags_left?.bags_left,
                customer_name: el.user?.name,
                phone: el.user?.phone,
                hno: el.customer?.location,
                type: el.is_manager == 0 ? "User" : "Manager",
                flagged: Number(el.flagged) === 1,
                status: getCommunityUserStatus(el),
              };
            });
            this.setState({
              community_users: details,
              showLoader: false,
              selectedRows: [],
              selectedIds: [],
              allRowsSelected: false,
            });
          } else {
            // console.log("err");
            this.setState({ showLoader: false });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ showLoader: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const generateFileName = (type: string, name: string) => {
      return type + "_Report_" + name + ".csv";
    };

    const handleDownloadBagInventroyReport = () => {
      this.setState({ showLoader: true });
      axios
        .get(
          "report/community/download/current-bag-inventory/" +
            this.state.community_id
        )
        .then((response: any) => {
          this.setState({ showLoader: false });
          let fileName = generateFileName(
            "Current_Bag_Inventory",
            this.state.communityName
          );
          const blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
        })
        .catch((error) => {
          this.setState({ showLoader: false });

          toast.error(
            error.response.data.message
              ? error.response.data.message
              : "Something went wrong",
            {
              position: "top-right",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        });
    };

    const handleAddUserToCommunity = () => {
      let user = this.state.userFilter;
      if (user) {
        this.setState({ showLoader: true });
        let body = {
          community_id: this.state.community_id,
          user_id: user.id,
        };
        axios
          .post("addUserToCommunity", body, {
            headers: { "Content-Type": "application/json" },
          })
          .then((response: any) => {
            if (response.data.success) {
              this.setState({
                showLoader: false,
                userFilter: null,
                userOptions: [],
              });
              toast.success(response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
              this.fetchCommunityUsers();
            } else {
              this.setState({
                showLoader: false,
                userFilter: null,
                userOptions: [],
              });
              toast.error(response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
              let errors = response.data.errors;
              for (var error in errors) {
                toast.error(errors[error][0], {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                });
              }
            }
          })
          .catch((error) => {
            this.setState({
              showLoader: false,
              userFilter: null,
              userOptions: [],
            });
            toast.error(error.response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          });
      }
    };

    const handleAssignUsersToGroup = () => {
      this.setState({ showLoader: true });
      let body = {
        community_id: this.state.community_id,
        group_id: this.state.selectedCommGroup,
        hierarchies: this.props.user.selectedHierarchyIds,
        users: this.state.selectedRows.map((userObj: any) => userObj.user_id),
      };
      axios
        .post("assignUsersToGroup", body, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          if (response.data.success) {
            // console.log("response", response.data.data);
            this.setState({ showLoader: false, selectedCommGroup: "" });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            // this.fetchCommunityUsers();
          } else {
            this.setState({ showLoader: false, selectedCommGroup: "" });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ showLoader: false, selectedCommGroup: "" });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    };

    const handleSelectAllChange = (e: any) => {
      if (e.target.checked) {
        let selectedRows = this.state.community_users.filter(
          (row) => row.status == "Active"
        );
        let selectedIds = selectedRows.map((row: any) => row.id);
        this.setState({
          allRowsSelected: true,
          selectedRows: selectedRows,
          selectedIds: selectedIds.sort(),
        });
      } else {
        this.setState({
          allRowsSelected: false,
          selectedRows: [],
          selectedIds: [],
        });
      }
    };

    const handleColumnVisibilityChange = (column: any) => {
      this.setState((prevState) => {
        const updatedTempColumnVisibility = {
          ...prevState.tempColumnVisibility,
          [column]: !prevState.tempColumnVisibility[column],
        };

        return {
          tempColumnVisibility: updatedTempColumnVisibility,
        };
      });
    };

    const handleColumnSelectorOk = () => {
      this.setState((prevState) => ({
        columnVisibility: { ...prevState.tempColumnVisibility },
        isColumnSelectorOpen: false,
      }));
    };

    const handleColumnSelectorCancel = () => {
      this.setState((prevState) => ({
        tempColumnVisibility: { ...prevState.columnVisibility },
        isColumnSelectorOpen: false,
      }));
    };

    const handleOpenModal = (row: any, actionType: string) => {
      this.setState({
        showModal: true,
        selectedUser: row,
        actionType,
        flaggedIsActive: Number(row.is_active) === 1 ? 1 : 0,
      });
    };

    const handleConfirmAction = () => {
      const { selectedUser, actionType, flaggedIsActive } = this.state;

      if (!selectedUser) return;

      this.setState({ showModal: false, showLoader: true });

      if (actionType === "type") {
        handleToggleUserType(selectedUser);
      } else if (actionType === "flagged") {
        handleToggleUserFlaggedStatus(selectedUser, flaggedIsActive);
      } else if (actionType === "status") {
        handleToggleUserStatus(selectedUser);
      }
    };

    // const communityGroup =
    //     [
    //         {
    //           "id": 14,
    //           "community_id": 6,
    //           "group_name": "Weekly-1",
    //           "is_active": 1,
    //           "created_at": "2019-05-06 03:43:09",
    //           "updated_at": "2019-05-06 09:13:09",
    //           "active_count": 31,
    //           "inactive_count": 7,
    //         },
    //         {
    //           "id": 15,
    //           "community_id": 6,
    //           "group_name": "Weekly-2",
    //           "is_active": 1,
    //           "created_at": "2019-05-06 03:43:25",
    //           "updated_at": "2019-05-06 09:13:25",
    //           "active_count": 0,
    //           "inactive_count": 1,
    //         },
    //         {
    //           "id": 56,
    //           "community_id": 6,
    //           "group_name": "Fortnightly-1/3",
    //           "is_active": 1,
    //           "created_at": "2019-05-06 03:43:39",
    //           "updated_at": "2019-05-06 09:13:39",
    //           "active_count": 0,
    //           "inactive_count": 0,
    //           "batch": []
    //         },
    //         {
    //           "id": 88,
    //           "community_id": 6,
    //           "group_name": "Fortnightly-2/4",
    //           "is_active": 1,
    //           "created_at": "2019-05-06 03:46:11",
    //           "updated_at": "2019-05-06 09:16:11",
    //           "active_count": 0,
    //           "inactive_count": 0,
    //           "batch": []
    //         }

    // ];

    const columns: any = [
      { field: "priority", headerName: "Priority", width: 100, editable: true },
      {
        field: "price",
        headerName: "Price",
        // type: 'number',
        // editable: true,
        // align: 'left',
        // headerAlign: 'left',
      },
      {
        field: "bag_price",
        headerName: "Bag",
        // type: 'number',
        // editable: true,
        // align: 'left',
        // headerAlign: 'left',
      },
      {
        field: "extra_bag_price",
        headerName: "Extra Price",
        // type: 'number',
        // editable: true,
        // align: 'left',
        // headerAlign: 'left',
      },
      {
        field: "bad_bag_charges",
        headerName: "Bad Bag Charges",
        // type: 'number',
        // editable: true,
        // align: 'left',
        // headerAlign: 'left',
      },
      {
        field: "bag_limit",
        headerName: "Bag Limit",
        // type: 'number',
        // editable: true,
        // align: 'left',
        // headerAlign: 'left',
      },
      {
        field: "user_id",
        headerName: "ID",
        // type: 'string',
        // editable: true,
        // align: 'left',
        // headerAlign: 'left',
        renderCell: (params: GridCellParams) => (
          <Typography
            variant="body2"
            sx={{ cursor: "pointer" }}
            onClick={() =>
              this.props.history.push(
                "/neighbourhood/customers/" + params.row.user_id
              )
            }
          >
            {params.row.user_id}
          </Typography>
        ),
      },
      {
        field: "bags_left",
        headerName: "Bags Left",
        // type: 'number',
        // editable: true,
        // align: 'left',
        // headerAlign: 'left',
      },
      {
        field: "customer_name",
        headerName: "Customer",
        // editable: true,
        // align: 'left',
        width: 180,
        // headerAlign: 'left',
        renderCell: (params: GridCellParams) => (
          <Typography
            variant="body2"
            sx={{ cursor: "pointer" }}
            onClick={() =>
              this.props.history.push(
                "/neighbourhood/customers/" + params.row.user_id
              )
            }
          >
            {renderMaskedCell(params.row.customer_name)}
          </Typography>
        ),
      },
      {
        field: "phone",
        headerName: "Phone",
        // editable: true,
        // align: 'left',
        width: 180,
        // headerAlign: 'left',
        renderCell: (params: GridCellParams) =>
          renderMaskedCell(params.value),
      },
      {
        field: "hno",
        headerName: "H.No",
        // editable: true,
        // align: 'left',
        // headerAlign: 'left',
        width: 300,
        renderCell: (params: GridCellParams) =>
          renderMaskedCell(params.value),
      },
      {
        field: "type",
        headerName: "Type",
        // editable: true,
        // align: 'left',
        // headerAlign: 'left',
        // type: 'singleSelect',
        valueOptions: ["User", "Manager"],
        renderCell: (params: GridCellParams) => (
          // <Typography className={(params.row.type == 'User') ? 'statusTextSuccess' : 'statusTextError'}>{params.row.type == 'User' ? "User" : "Manager"}</Typography>
          <Button
            variant="contained"
            size="small"
            color={params.row.type == "User" ? "success" : "warning"}
            onClick={() => handleToggleUserType(params.row)}
          >
            {params.row.type == "User" ? "User" : "Manager"}
          </Button>
        ),
      },
      {
        field: "status",
        headerName: "Status",
        // editable: true,
        // align: 'left',
        // headerAlign: 'left',
        // type: 'singleSelect',
        valueOptions: ["Active", "Inactive", "Flagged"],
        renderCell: (params: GridCellParams) => (
          <Button
            variant="contained"
            size="small"
            {...getStatusButtonProps(params.row.status)}
            onClick={() =>
              params.row.status === "Flagged"
                ? handleToggleUserFlaggedStatus(params.row)
                : handleToggleUserStatus(params.row)
            }
          >
            {params.row.status}
          </Button>
        ),
      },
      {
        field: "actions",
        type: "actions",
        headerName: "Actions",
        width: 100,
        cellClassName: "actions",
        hide: true,
        getActions: (params: GridRowParams) => [
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => handleDeleteUser(params.row)}
            color="inherit"
          />,
        ],
      },
    ];

    const handlePriorityChange = (userId: number, value: string) => {
      this.setState((prevState) => ({
        priorities: {
          ...prevState.priorities,
          [userId]: value,
        },
      }));
    };

    const handlePrioritySubmit = (userId: number) => {
      const { priorities } = this.state;
      const priorityValue =
        priorities[userId] !== undefined ? priorities[userId] : "";

      const payload = {
        hierarchies: this.props.user.selectedHierarchyIds,
        priority: priorityValue,
        community_user_id: userId,
      };

      axios
        .post("setCustomerHousePriority", payload, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response: any) => {
          this.setState({ showLoader: false });
          if (response.data.success) {
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            this.fetchCommunityUsers();
            this.setState({ priorities: {} });
            if (document.activeElement instanceof HTMLElement) {
              document.activeElement.blur();
            }
          } else {
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
            this.fetchCommunityUsers();
          }
        })
        .catch((error) => {
          this.setState({ showLoader: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          this.fetchCommunityUsers();
        });
    };

    return (
      <div>
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
          open={this.state.showLoader}
          // onClick={() => this.setState({ showLoader: false })}
        >
          <CircularProgress className="customLoader" />
        </Backdrop>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <NeighbourhoodHeader user={this.props.user} />
        <Grid container spacing={2}>
          <Grid item md={12} xs={12} className="mt-3">
            <Card>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="community-users-content"
                  id="community-users-header"
                >
                  <Grid container alignItems="center" spacing={2}>
                    {/* Community Users Title */}
                    <Grid item>
                      <Typography variant="h5" sx={{ lineHeight: "40px" }}>
                        Community Users
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography>
                        List of {this.state.communityName} Users (Active:{" "}
                        {this.state.activeUserCount} | Inactive:{" "}
                        {this.state.inactiveUserCount} | Flagged:{" "}
                        {this.state.flaggedUserCount})
                      </Typography>
                    </Grid>
                    <Grid item xs>
                      <Box sx={{ pr: 4 }}>
                        <Stack
                          direction="row"
                          spacing={2}
                          sx={{ justifyContent: "flex-end" }}
                        >
                          {/* <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => handleDownloadBagInventroyReport()}>
                                Download Bag Inventory Report
                            </Button> */}
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ outline: "none !important" }}
                            onClick={() =>
                              this.setState({
                                showBagDistribution: true,
                                bagCount: 6,
                              })
                            }
                          >
                            New Bag Distribution
                          </Button>
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ outline: "none !important" }}
                            href={`/neighbourhood/community-list/${this.state.community_id}/pickups`}
                            className="link"
                          >
                            Pickups
                          </Button>
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ outline: "none !important" }}
                            href={`/neighbourhood/community-list/${this.state.community_id}`}
                            className="link"
                          >
                            Details
                          </Button>
                        </Stack>
                      </Box>
                    </Grid>
                  </Grid>
                </AccordionSummary>

                <AccordionDetails>
                  {/* First CardContent Section */}
                  <Grid container spacing={1}>
                    <Grid item md={6} xs={12}>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="combo-box-demo"
                          fullWidth
                          options={this.state.userOptions}
                          value={this.state.userFilter}
                          onChange={(value, newValue) => {
                            this.setState({ userFilter: newValue }, () =>
                              handleAddUserToCommunity()
                            );
                          }}
                          onKeyDown={(e: any) =>
                            this.fetchCustomerLite(e.target.value)
                          }
                          getOptionLabel={(option) =>
                            `${option.name} - ${option.phone} (${option.hierarchy.name})`
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Add Users"
                              size="small"
                              sx={{
                                height: "40px",
                                fontSize: "0.875rem",
                              }}
                            />
                          )}
                          size="small"
                          sx={{
                            height: "40px",
                            padding: "0",
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <Button
                        variant="contained"
                        fullWidth
                        size="small"
                        sx={{
                          height: "40px",
                          fontSize: "0.8rem",
                          textTransform: "uppercase",
                          padding: "0 6px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        onClick={() =>
                          this.setState({ showAddCommunityGroup: true })
                        }
                      >
                        Add Community Group
                      </Button>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      {/* <Button
                            variant="contained"
                            fullWidth
                            size="small"
                            sx={{
                                height: '40px',
                                fontSize: '0.8rem',
                                textTransform: 'uppercase',
                                padding: '0 6px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                            onClick={() => this.setState({ showBagDistribution: true })}
                        >
                            New Bag Distribution
                        </Button> */}
                      <Button
                        variant="contained"
                        fullWidth
                        size="small"
                        sx={{
                          height: "40px",
                          fontSize: "0.8rem",
                          textTransform: "uppercase",
                          padding: "0 6px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        onClick={() => handleDownloadBagInventroyReport()}
                      >
                        Download Bag Inventory
                      </Button>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <Button
                        variant="contained"
                        fullWidth
                        size="small"
                        sx={{
                          height: "40px",
                          fontSize: "0.8rem",
                          textTransform: "uppercase",
                          padding: "0 6px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        onClick={() => this.setState({ showBatchPickup: true })}
                      >
                        New Batch Pickups
                      </Button>
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 2 }} />

                  {/* Second CardContent Section */}
                  <Grid container spacing={1}>
                    <Grid item md={6} xs={12}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <Grid
                          container
                          spacing={2}
                          sx={{ verticalAlign: "middle" }}
                        >
                          <Grid item md={4} xs={12}>
                            <FormControl fullWidth={true}>
                              <TextField
                                id="filter-input"
                                label={t("Search")}
                                name="filter"
                                value={this.state.filter}
                                onChange={(e: any) =>
                                  this.setState(
                                    { filter: e.target.value },
                                    () => handleFilterCommunityUsers()
                                  )
                                }
                                fullWidth={true}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <FormControl fullWidth={true}>
                              <InputLabel id="city-label">
                                Community Groups
                              </InputLabel>
                              <Select
                                labelId="city-label"
                                value={this.state.filterCommGroup}
                                onChange={(e) =>
                                  this.setState(
                                    { filterCommGroup: e.target.value },
                                    () => handleFilterCommunityUsers()
                                  )
                                }
                                displayEmpty
                                label="Community Groups"
                                fullWidth={true}
                                sx={{ textAlign: "left" }}
                              >
                                <MenuItem key={-1} value={"all"}>
                                  All
                                </MenuItem>
                                {this.state.communityGroup?.map((el: any) => (
                                  <MenuItem key={el.id} value={el.id}>
                                    {el.group_name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid
                            item
                            md={4}
                            xs={12}
                            sx={{ marginTop: 0, marginBottom: 0 }}
                          >
                            <FormControl
                              fullWidth={true}
                              sx={{ marginTop: 0, marginBottom: 0 }}
                            >
                              <TextField
                                id="filter-input"
                                label={t("Bag Left Count")}
                                name="filter"
                                value={this.state.bagsLeftCount}
                                onChange={(e: any) =>
                                  this.setState(
                                    { bagsLeftCount: e.target.value },
                                    () => handleFilterCommunityUsers()
                                  )
                                }
                                fullWidth={true}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <Grid container spacing={2}>
                        <Grid item md={6} xs={12}>
                          {/* <Button variant="contained" fullWidth={true} size="small" onClick={() => this.setState({ showBadBagModal: true })}>
                                    Update Bad Bag Charges
                                </Button> */}
                          <Button
                            variant="contained"
                            fullWidth
                            size="small"
                            disabled={
                              ![
                                "kedarnath@bintix.com",
                                "satheesh@bintix.com",
                              ].includes(this.props.user.email)
                            }
                            onClick={() =>
                              this.setState({ showBadBagModal: true })
                            }
                          >
                            Update Bad Bag Charges
                          </Button>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          {/* <Button variant="contained" fullWidth={true} size="small" onClick={() => this.setState({ showUpdateBagPrice: true })}>
                                    Update Bag Price
                                </Button> */}
                          <Button
                            variant="contained"
                            fullWidth
                            size="small"
                            disabled={
                              ![
                                "kedarnath@bintix.com",
                                "satheesh@bintix.com",
                              ].includes(this.props.user.email)
                            }
                            onClick={() =>
                              this.setState({ showUpdateBagPrice: true })
                            }
                          >
                            Update Bag Price
                          </Button>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          {/* <Button variant="contained" fullWidth={true} size="small" onClick={() => this.setState({ showUpdatePrice: true })}>
                                    Update Price
                                </Button> */}
                          <Button
                            variant="contained"
                            fullWidth
                            size="small"
                            disabled={
                              ![
                                "kedarnath@bintix.com",
                                "satheesh@bintix.com",
                              ].includes(this.props.user.email)
                            }
                            onClick={() =>
                              this.setState({ showUpdatePrice: true })
                            }
                          >
                            Update Price
                          </Button>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Button
                            variant="contained"
                            fullWidth={true}
                            size="small"
                            onClick={() => this.setState({ showMessage: true })}
                          >
                            Send Message
                          </Button>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Button
                            variant="contained"
                            fullWidth={true}
                            size="small"
                            onClick={() =>
                              this.setState({ showBagLimit: true })
                            }
                          >
                            Update Bag Limit
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 2 }} />
                </AccordionDetails>
              </Accordion>
              <CardContent>
                <Typography sx={{ textAlign: "left" }}>
                  Community Groups:
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <Grid container spacing={2}>
                    {this.state.communityGroup?.map(
                      (el: any, index: number) => (
                        <Grid item md={3} xs={12} key={index}>
                          <Paper
                            elevation={3}
                            sx={{ borderRadius: "5px", cursor: "pointer" }}
                            onClick={() =>
                              this.setState({
                                showEditGroup: true,
                                editGroup: el,
                              })
                            }
                          >
                            <Typography sx={{ padding: "10px" }}>
                              {el.group_name +
                                " (A:" +
                                el.active_count +
                                " | I:" +
                                el.inactive_count +
                                ")"}
                            </Typography>
                          </Paper>
                        </Grid>
                      )
                    )}
                  </Grid>
                </Box>
              </CardContent>
              <hr style={{ margin: "0px" }} />
              {this.state.selectedRows.length != 0 && (
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item md={6} xs={12}>
                      <FormControl fullWidth={true} size={"small"}>
                        <InputLabel id="city-label">
                          Community Groups
                        </InputLabel>
                        <Select
                          labelId="city-label"
                          value={this.state.selectedCommGroup}
                          onChange={(e) =>
                            this.setState({ selectedCommGroup: e.target.value })
                          }
                          displayEmpty
                          label="Community Groups"
                          fullWidth={true}
                          sx={{ textAlign: "left" }}
                        >
                          {this.state.communityGroup?.map((el: any) => {
                            return (
                              <MenuItem key={el.id} value={el.id}>
                                {el.group_name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <Button
                        variant="contained"
                        size="small"
                        disabled={!this.state.selectedCommGroup}
                        onClick={() => handleAssignUsersToGroup()}
                      >
                        Assign Users to Community Group
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              )}
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    marginBottom: 2,
                  }}
                >
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() =>
                      this.setState({ isColumnSelectorOpen: true })
                    }
                  >
                    Select Columns
                  </Button>

                  {/* Box for Filter and Icon */}
                  {this.state.isColumnSelectorOpen && (
                    <Box
                      sx={{
                        position: "absolute",
                        backgroundColor: "#fff",
                        padding: 2,
                        border: "1px solid #ccc",
                        zIndex: 100,
                        width: 300,
                      }}
                    >
                      {/* Input Field for Filtering */}
                      <TextField
                        fullWidth
                        placeholder="Enter property name or value"
                        onChange={(e) =>
                          this.setState({ filterText: e.target.value })
                        }
                      />
                      <Box
                        sx={{
                          maxHeight: 300, // Adjust the height as per your UI requirements
                          overflowY: "auto",
                          marginTop: 2,
                        }}
                      >
                        {/* List of Columns */}
                        {Object.keys(this.state.tempColumnVisibility)
                          .filter((column) =>
                            column.includes(this.state.filterText || "")
                          )
                          .map((column) => (
                            <FormControlLabel
                              key={column}
                              control={
                                <Checkbox
                                  checked={
                                    this.state.tempColumnVisibility[column]
                                  }
                                  onChange={() =>
                                    handleColumnVisibilityChange(column)
                                  }
                                />
                              }
                              label={column}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 1,
                                textAlign: "left",
                              }}
                            />
                          ))}
                      </Box>

                      {/* Bottom Buttons */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: 2,
                        }}
                      >
                        <Button
                          variant="outlined"
                          sx={{ marginRight: 1 }}
                          onClick={handleColumnSelectorCancel}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          onClick={handleColumnSelectorOk}
                        >
                          OK
                        </Button>
                      </Box>
                    </Box>
                  )}
                </Box>

                <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
                  <Table
                    stickyHeader
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                  >
                    {/* <TableHead>
                                            <TableRow>
                                                <TableCell sx={customTableCellStyle}>
                                                    <Checkbox aria-label='Select ALl' onChange={(e) => handleSelectAllChange(e)} checked={this.state.allRowsSelected} />
                                                </TableCell>
                                                <TableCell sx={customTableHeaderCellStyle}>Priority</TableCell>
                                                <TableCell sx={customTableHeaderCellStyle}>Price</TableCell>
                                                <TableCell sx={customTableHeaderCellStyle}>Bag</TableCell>
                                                <TableCell sx={customTableHeaderCellStyle}>Extra Price</TableCell>
                                                <TableCell sx={customTableHeaderCellStyle}>Bad Bag Charges</TableCell>
                                                <TableCell sx={customTableHeaderCellStyle}>Bag Limit</TableCell>
                                                <TableCell sx={customTableHeaderCellStyle}>ID</TableCell>
                                                <TableCell sx={customTableHeaderCellStyle}>Bags Left</TableCell>
                                                <TableCell sx={customTableHeaderCellStyle}>Customer</TableCell>
                                                <TableCell sx={customTableHeaderCellStyle}>Phone</TableCell>
                                                <TableCell sx={customTableHeaderCellStyle}>H.No</TableCell>
                                                <TableCell sx={customTableHeaderCellStyle}>Type</TableCell>
                                                <TableCell sx={customTableHeaderCellStyle}>Status</TableCell>
                                                {false && <TableCell sx={customTableHeaderCellStyle}>Actions</TableCell>}
                                            </TableRow>
                                        </TableHead> */}
                    <TableHead>
                      <TableRow>
                        {/* Checkbox for Selecting All */}
                        <TableCell sx={customTableCellStyle}>
                          <Checkbox
                            aria-label="Select All"
                            onChange={(e) => handleSelectAllChange(e)}
                            checked={this.state.allRowsSelected}
                          />
                        </TableCell>

                        {/* Dynamically Render Table Headers Based on Column Visibility */}
                        {Object.keys(this.state.columnVisibility).map(
                          (column) =>
                            this.state.columnVisibility[column] && (
                              <TableCell
                                key={column}
                                sx={customTableHeaderCellStyle}
                              >
                                {column}
                              </TableCell>
                            )
                        )}
                      </TableRow>
                    </TableHead>
                    {/* <TableBody>
                                            {this.state.community_users.map((row, rowKey: number) => (
                                                <TableRow
                                                    key={row.id}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    className={(row.status == "Active") ? "" : "bg-gray"}
                                                >
                                                    <TableCell sx={customTableCellStyle}>
                                                        <Checkbox
                                                            aria-label='Select ALl'
                                                            disabled={row.status != "Active"}
                                                            checked={this.state.selectedIds.includes(row.id)}
                                                            onChange={(e: any) => {
                                                                if (e.target.checked) {
                                                                    let allRows = this.state.community_users.filter((row_item) =>
                                                                        (row_item.status == "Active")
                                                                    );
                                                                    let allIds = allRows.map((row_item: any) => row_item.id);

                                                                    let selectedIds = this.state.selectedIds;
                                                                    selectedIds.push(row.id);
                                                                    let selectedRows = this.state.selectedRows;
                                                                    selectedRows.push(row);
                                                                    this.setState({ selectedIds, selectedRows, allRowsSelected: (allIds.length == selectedIds.length) });
                                                                } else {
                                                                    let selectedIds = this.state.selectedIds;
                                                                    selectedIds = selectedIds.filter((element: any) => element !== row.id);
                                                                    let selectedRows = this.state.selectedRows;
                                                                    selectedRows = selectedRows.filter((element: any) => element.id !== row.id);
                                                                    this.setState({ selectedIds, selectedRows, allRowsSelected: false });
                                                                }
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>{row.priority}</TableCell>
                                                    <TableCell>{row.price}</TableCell>
                                                    <TableCell>{row.bag_price}</TableCell>
                                                    <TableCell>{row.extra_bag_price}</TableCell>
                                                    <TableCell>{row.bad_bag_charges}</TableCell>
                                                    <TableCell>{row.bag_limit}</TableCell>
                                                    <TableCell>
                                                        <Typography variant='body2' sx={{ cursor: 'pointer' }}
                                                            // onClick={() => this.props.history.push('/neighbourhood/customers/' + row.user_id)}
                                                            onClick={() => window.open(`/neighbourhood/customers/${row.user_id}`, '_blank')}
                                                        >{row.user_id}</Typography>
                                                    </TableCell>
                                                    <TableCell>{row.bags_left}</TableCell>
                                                    <TableCell sx={{ whiteSpace: 'nowrap' }} size='small'>
                                                        <Typography variant='body2' sx={{ cursor: 'pointer' }}
                                                            // onClick={() => this.props.history.push('/neighbourhood/customers/' + row.user_id)}
                                                            onClick={() => window.open(`/neighbourhood/customers/${row.user_id}`, '_blank')}
                                                        >{row.customer_name}</Typography>
                                                    </TableCell>
                                                    <TableCell>{row.phone}</TableCell>
                                                    <TableCell>{row.hno}</TableCell>
                                                    <TableCell>
                                                        <Button variant="contained" size='small' color={row.type == "User" ? "success" : "warning"} onClick={() => handleToggleUserType(row)}>{row.type == "User" ? "User" : "Manager"}</Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button variant="contained" size='small' color={row.status == "Active" ? "success" : "warning"} onClick={() => handleToggleUserStatus(row)}>{row.status == "Active" ? "Active" : "Inactive"}</Button>
                                                    </TableCell>
                                                    {false && <TableCell>
                                                        <IconButton aria-label="Delete" component="span" onClick={() => handleDeleteUser(row)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </TableCell>}
                                                </TableRow>
                                            ))}
                                        </TableBody> */}
                    <TableBody>
                      {this.state.community_users.map((row, rowKey: number) => (
                        <TableRow
                          key={row.id}
                          className={
                            row.status === "Inactive" ? "bg-gray" : ""
                          }
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            ...(row.status === "Flagged" && {
                              backgroundColor: "#d1d5db",
                            }),
                          }}
                        >
                          {/* Checkbox */}
                          <TableCell sx={customTableCellStyle}>
                            <Checkbox
                              aria-label="Select All"
                              disabled={row.status !== "Active"}
                              checked={this.state.selectedIds.includes(row.id)}
                              onChange={(e: any) => {
                                if (e.target.checked) {
                                  let allRows =
                                    this.state.community_users.filter(
                                      (row_item) => row_item.status === "Active"
                                    );
                                  let allIds = allRows.map(
                                    (row_item: any) => row_item.id
                                  );

                                  let selectedIds = [
                                    ...this.state.selectedIds,
                                    row.id,
                                  ];
                                  let selectedRows = [
                                    ...this.state.selectedRows,
                                    row,
                                  ];
                                  this.setState({
                                    selectedIds,
                                    selectedRows,
                                    allRowsSelected:
                                      allIds.length === selectedIds.length,
                                  });
                                } else {
                                  let selectedIds =
                                    this.state.selectedIds.filter(
                                      (id: any) => id !== row.id
                                    );
                                  let selectedRows =
                                    this.state.selectedRows.filter(
                                      (item: any) => item.id !== row.id
                                    );
                                  this.setState({
                                    selectedIds,
                                    selectedRows,
                                    allRowsSelected: false,
                                  });
                                }
                              }}
                            />
                          </TableCell>

                          {/* Dynamically Render Columns */}
                          {this.state.columnVisibility.Priority && (
                            // <TableCell>{row.priority}</TableCell>
                            <TableCell>
                              <TextField
                                value={
                                  this.state.priorities[row.id] !== undefined
                                    ? this.state.priorities[row.id]
                                    : row.priority
                                }
                                onChange={(e) =>
                                  handlePriorityChange(row.id, e.target.value)
                                }
                                onKeyDown={(e) =>
                                  e.key === "Enter" &&
                                  handlePrioritySubmit(row.id)
                                }
                                size="small"
                                variant="outlined"
                                sx={{ width: 80 }}
                              />
                            </TableCell>
                          )}
                          {this.state.columnVisibility.Price && (
                            <TableCell>{row.price}</TableCell>
                          )}
                          {this.state.columnVisibility.Bag && (
                            <TableCell>{row.bag_price}</TableCell>
                          )}
                          {this.state.columnVisibility.ExtraPrice && (
                            <TableCell>{row.extra_bag_price}</TableCell>
                          )}
                          {this.state.columnVisibility.BadBagCharges && (
                            <TableCell>{row.bad_bag_charges}</TableCell>
                          )}
                          {this.state.columnVisibility.BagLimit && (
                            <TableCell>{row.bag_limit}</TableCell>
                          )}
                          {this.state.columnVisibility.ID && (
                            <TableCell>
                              <Typography
                                variant="body2"
                                sx={{ cursor: "pointer" }}
                                onClick={() =>
                                  window.open(
                                    `/neighbourhood/customers/${row.user_id}`,
                                    "_blank"
                                  )
                                }
                              >
                                {row.user_id}
                              </Typography>
                            </TableCell>
                          )}
                          {this.state.columnVisibility.BagsLeft && (
                            <TableCell>{row.bags_left}</TableCell>
                          )}
                          {this.state.columnVisibility.Customer && (
                            <TableCell
                              sx={{ whiteSpace: "nowrap" }}
                              size="small"
                            >
                              <Typography
                                variant="body2"
                                sx={{ cursor: "pointer" }}
                                onClick={() =>
                                  window.open(
                                    `/neighbourhood/customers/${row.user_id}`,
                                    "_blank"
                                  )
                                }
                              >
                                {renderMaskedCell(row.customer_name)}
                              </Typography>
                            </TableCell>
                          )}
                          {this.state.columnVisibility.Phone && (
                            <TableCell>{renderMaskedCell(row.phone)}</TableCell>
                          )}
                          {this.state.columnVisibility.HNo && (
                            <TableCell>{renderMaskedCell(row.hno)}</TableCell>
                          )}
                          {this.state.columnVisibility.Type && (
                            <TableCell>
                              <Button
                                variant="contained"
                                size="small"
                                color={
                                  row.type === "User" ? "success" : "warning"
                                }
                                onClick={() => handleOpenModal(row, "type")}
                              >
                                {row.type === "User" ? "User" : "Manager"}
                              </Button>
                            </TableCell>
                          )}
                          {this.state.columnVisibility.Status && (
                            <TableCell>
                              <Button
                                variant="contained"
                                size="small"
                                {...getStatusButtonProps(row.status)}
                                onClick={() =>
                                  handleOpenModal(
                                    row,
                                    row.status === "Flagged"
                                      ? "flagged"
                                      : "status"
                                  )
                                }
                              >
                                {row.status}
                              </Button>
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Modal
          open={this.state.showAddCommunityGroup}
          onClose={() => this.setState({ showAddCommunityGroup: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title="New Group"
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() =>
                      this.setState({ showAddCommunityGroup: false })
                    }
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <TextField
                      id="agent-name-input"
                      label="Group Name"
                      value={this.state.newGroup}
                      onChange={(e: any) =>
                        this.setState({ newGroup: e.target.value })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() =>
                    this.setState({ showAddCommunityGroup: false })
                  }
                >
                  Close
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleAddCommunityGroup()}
                >
                  Add New Group
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showBagDistribution}
          onClose={() => this.setState({ showBagDistribution: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title="New Bag Distribution"
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() =>
                      this.setState({ showBagDistribution: false })
                    }
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          views={["year", "month", "day"]}
                          mask="____-__-__"
                          renderInput={(props) => <TextField {...props} />}
                          label="Date"
                          disablePast
                          value={this.state.date}
                          onChange={(newValue: any) => {
                            this.setState({ date: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="city-label">Distribution Type</InputLabel>
                      <Select
                        labelId="city-label"
                        value={this.state.distributionType}
                        onChange={(e) =>
                          this.setState({ distributionType: e.target.value })
                        }
                        displayEmpty
                        label="Distribution Type"
                        fullWidth={true}
                      >
                        <MenuItem key={1} value={"regular"}>
                          Regular
                        </MenuItem>
                        <MenuItem key={2} value={"ondemand"}>
                          On Demand
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextField
                      id="agent-name-input"
                      label="Bags"
                      value={this.state.bagCount}
                      onChange={(e: any) =>
                        this.setState({ bagCount: e.target.value })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="city-label">Agents</InputLabel>
                      <Select
                        labelId="city-label"
                        value={this.state.allotedAgents}
                        onChange={(e) =>
                          this.setState({ allotedAgents: e.target.value })
                        }
                        displayEmpty
                        label="Agents"
                        fullWidth={true}
                      >
                        {/* <MenuItem key={1} value={1}>Regular</MenuItem>
                                                <MenuItem key={2} value={2}>On Demand</MenuItem> */}
                        {this.state.agents?.map((el: any) => {
                          return (
                            <MenuItem key={el.id} value={el.id}>
                              {el.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <br />
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.overrideMinimumBagsReceived}
                        onClick={() =>
                          this.setState({
                            overrideMinimumBagsReceived:
                              !this.state.overrideMinimumBagsReceived,
                          })
                        }
                      />
                    }
                    label={
                      <Typography>
                        Override requirement for{" "}
                        <b>"At least one pickup completed in last 4 weeks"</b>
                      </Typography>
                    }
                  />
                </FormGroup>
                {/* <div style={{display: 'flex', justifyContent: 'left', alignItems: 'center', verticalAlign: 'center'}}>
                                    <Checkbox/>
                                    <Typography>Override requirement for <b>"At least one pickup completed in last 4 weeks"</b></Typography>
                                </div> */}
                <br />
                {this.state.selectedRows.length == 0 ? (
                  <Alert variant="outlined" severity="error">
                    Please select atleast one user to create a batch.
                  </Alert>
                ) : (
                  <Alert variant="outlined" severity="success">
                    Creating Batch bag Distributions for selected{" "}
                    {this.state.selectedRows.length} users.
                  </Alert>
                )}
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showBagDistribution: false })}
                >
                  Close
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => bagDistribution()}
                >
                  Confirm Distribution
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showBatchPickup}
          onClose={() => this.setState({ showBatchPickup: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title="New Batch Pickup"
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showBatchPickup: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          inputFormat="yyyy-MM-dd"
                          views={["year", "month", "day"]}
                          mask="____-__-__"
                          renderInput={(props) => <TextField {...props} />}
                          label="Date"
                          disablePast
                          value={this.state.pickupDate}
                          onChange={(newValue: any) => {
                            this.setState({ pickupDate: newValue });
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="city-label">Slot</InputLabel>
                      <Select
                        labelId="city-label"
                        value={this.state.slot}
                        onChange={(e) =>
                          this.setState({ slot: e.target.value })
                        }
                        displayEmpty
                        label="Slot"
                        fullWidth={true}
                      >
                        <MenuItem key={20} value={20}>
                          Morning
                        </MenuItem>
                        <MenuItem key={21} value={21}>
                          Afternoon
                        </MenuItem>
                        <MenuItem key={22} value={22}>
                          Evening
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="city-label">Agents</InputLabel>
                      <Select
                        labelId="city-label"
                        value={this.state.allotedPickupAgents}
                        onChange={(e) =>
                          this.setState({ allotedPickupAgents: e.target.value })
                        }
                        displayEmpty
                        label="Agents"
                        fullWidth={true}
                      >
                        {/* <MenuItem key={1} value={1}>Regular</MenuItem>
                                                <MenuItem key={2} value={2}>On Demand</MenuItem> */}
                        {this.state.agents?.map((el: any) => {
                          return (
                            <MenuItem key={el.id} value={el.id}>
                              {el.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <br />
                {this.state.selectedRows.length == 0 ? (
                  <Alert variant="outlined" severity="error">
                    Please select atleast one user to create a batch.
                  </Alert>
                ) : (
                  <Alert variant="outlined" severity="success">
                    Creating Batch pickups for selected{" "}
                    {this.state.selectedRows.length} users.
                  </Alert>
                )}
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showBatchPickup: false })}
                >
                  Close
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleNewBatchPickup()}
                >
                  Confirm Batch
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showBadBagModal}
          onClose={() => this.setState({ showBadBagModal: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title="Bulk Bad Bag Charges Update"
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showBadBagModal: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <TextField
                      id="agent-name-input"
                      label="Charges"
                      value={this.state.charges}
                      onChange={(e: any) =>
                        this.setState({ charges: e.target.value })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <br />
                {this.state.selectedRows.length == 0 ? (
                  <Alert variant="outlined" severity="error">
                    Please select atleast one user to update Bad Bag Charges.
                  </Alert>
                ) : (
                  <Alert variant="outlined" severity="success">
                    Updating Bad Bag Charges of selected{" "}
                    {this.state.selectedRows.length} users.
                  </Alert>
                )}
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showBadBagModal: false })}
                >
                  Close
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleBadBagCharges()}
                >
                  Update Charges
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showUpdateBagPrice}
          onClose={() => this.setState({ showUpdateBagPrice: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title="Bulk Bag Price Update"
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showUpdateBagPrice: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="agent-name-input"
                      label="Price"
                      value={this.state.bagPrice}
                      onChange={(e: any) =>
                        this.setState({ bagPrice: e.target.value })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <InputLabel id="city-label">Type</InputLabel>
                      <Select
                        labelId="city-label"
                        value={this.state.bagPriceUpdateType}
                        onChange={(e) =>
                          this.setState({ bagPriceUpdateType: e.target.value })
                        }
                        displayEmpty
                        label="Type"
                        fullWidth={true}
                      >
                        <MenuItem key={1} value={"normal"}>
                          Regular
                        </MenuItem>
                        <MenuItem key={2} value={"extra"}>
                          Extra
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <br />
                {this.state.selectedRows.length == 0 ? (
                  <Alert variant="outlined" severity="error">
                    Please select atleast one user to update price.
                  </Alert>
                ) : (
                  <Alert variant="outlined" severity="success">
                    Updating price of selected {this.state.selectedRows.length}{" "}
                    users.
                  </Alert>
                )}
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showUpdateBagPrice: false })}
                >
                  Close
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleCustomerBagPrice()}
                >
                  Update Price
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showUpdatePrice}
          onClose={() => this.setState({ showUpdatePrice: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title="Bulk Price Update"
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showUpdatePrice: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="agent-name-input"
                      label="Price"
                      value={this.state.bulkPrice}
                      onChange={(e: any) =>
                        this.setState({ bulkPrice: e.target.value })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <br />
                {this.state.selectedRows.length == 0 ? (
                  <Alert variant="outlined" severity="error">
                    Please select atleast one user to update price.
                  </Alert>
                ) : (
                  <Alert variant="outlined" severity="success">
                    Updating price of selected {this.state.selectedRows.length}{" "}
                    users.
                  </Alert>
                )}
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showUpdatePrice: false })}
                >
                  Close
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleCustomerPrice()}
                >
                  Update Price
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showBagLimit}
          onClose={() => this.setState({ showBagLimit: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title="Bulk Bag Limit Update"
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showBagLimit: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      id="agent-name-input"
                      label="Limit"
                      value={this.state.bulkBagLimit}
                      onChange={(e: any) =>
                        this.setState({ bulkBagLimit: e.target.value })
                      }
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <br />
                {this.state.selectedRows.length == 0 ? (
                  <Alert variant="outlined" severity="error">
                    Please select atleast one user to update Bag Limit.
                  </Alert>
                ) : (
                  <Alert variant="outlined" severity="success">
                    Updating bag limit of selected{" "}
                    {this.state.selectedRows.length} users.
                  </Alert>
                )}
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showBagLimit: false })}
                >
                  Close
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleUpdateBagLimit()}
                >
                  Update Limit
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showMessage}
          onClose={() => this.setState({ showMessage: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{ overflowY: "scroll" }}
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title="New Message"
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showMessage: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={12} xs={12}>
                    <TextField
                      id="agent-name-input"
                      label="Message"
                      value={this.state.newMessage}
                      onChange={(e: any) =>
                        this.setState({ newMessage: e.target.value })
                      }
                      fullWidth={true}
                      multiline
                    />
                  </Grid>
                </Grid>
                <br />
                {this.state.selectedRows.length == 0 ? (
                  <Alert variant="outlined" severity="error">
                    Please select atleast one user to send message.
                  </Alert>
                ) : (
                  <Alert variant="outlined" severity="success">
                    Sending sms to selected {this.state.selectedRows.length}{" "}
                    users.
                  </Alert>
                )}
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showMessage: false })}
                >
                  Close
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleSendMessage()}
                >
                  Send Message
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Modal
          open={this.state.showEditGroup}
          onClose={() => this.setState({ showEditGroup: false })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Card>
              <CardHeader
                title="Edit Group"
                className="text-left"
                action={
                  <IconButton
                    color="primary"
                    className="customIconButton"
                    aria-label="upload picture"
                    component="span"
                    onClick={() => this.setState({ showEditGroup: false })}
                  >
                    <CloseOutlined />
                  </IconButton>
                }
              />
              <CardContent>
                <Divider className="mb-3" />
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <TextField
                      id="agent-name-input"
                      label="Group Name"
                      value={this.state.editGroup?.group_name}
                      onChange={(e: any) => {
                        this.setState({
                          editGroup: {
                            ...this.state.editGroup,
                            group_name: e.target.value,
                          },
                        });
                      }}
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <Divider className="mt-3" />
              </CardContent>
              <CardActions className="float-right">
                <Button
                  size="small"
                  className="customCloseButton"
                  onClick={() => this.setState({ showEditGroup: false })}
                >
                  Close
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleEditCommunityGroup()}
                >
                  Update Group
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Modal>
        <Dialog
          open={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{ fontWeight: 600, paddingBottom: 1 }}
          >
            {this.state.actionType === "flagged"
              ? "Are you sure you want to remove the flagged status and set this user as active or inactive?"
              : this.state.actionType === "type"
              ? "Change user type?"
              : "Change user status?"}
          </DialogTitle>
          <DialogContent
            id="alert-dialog-description"
            sx={{ paddingTop: "8px !important" }}
          >
            {this.state.actionType === "flagged" && (
              <>
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 600, marginBottom: 1.5 }}
                >
                  User status
                </Typography>
                <FormControl fullWidth>
                  <RadioGroup
                    row
                    name="flagged-user-active-status"
                    value={String(this.state.flaggedIsActive)}
                    sx={{ gap: 1.5, flexWrap: "nowrap" }}
                    onChange={(event) =>
                      this.setState({
                        flaggedIsActive: Number(event.target.value),
                      })
                    }
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio color="success" />}
                      label="Active"
                      sx={{
                        flex: 1,
                        margin: 0,
                        padding: "6px 12px",
                        border: "1px solid",
                        borderColor:
                          this.state.flaggedIsActive === 1
                            ? "success.main"
                            : "divider",
                        borderRadius: 1.5,
                        backgroundColor:
                          this.state.flaggedIsActive === 1
                            ? "rgba(46, 125, 50, 0.08)"
                            : "transparent",
                      }}
                    />
                    <FormControlLabel
                      value="0"
                      control={<Radio color="warning" />}
                      label="Inactive"
                      sx={{
                        flex: 1,
                        margin: 0,
                        padding: "6px 12px",
                        border: "1px solid",
                        borderColor:
                          this.state.flaggedIsActive === 0
                            ? "warning.main"
                            : "divider",
                        borderRadius: 1.5,
                        backgroundColor:
                          this.state.flaggedIsActive === 0
                            ? "rgba(237, 108, 2, 0.08)"
                            : "transparent",
                      }}
                    />
                  </RadioGroup>
                </FormControl>
              </>
            )}
            {this.state.actionType !== "flagged" && (
              <Typography color="text.secondary">
                Are you sure you want to continue with this change?
              </Typography>
            )}
          </DialogContent>
          <DialogActions sx={{ padding: "16px 24px 24px", gap: 1 }}>
            <Button
              onClick={() => this.setState({ showModal: false })}
              className="customCloseButton"
              variant="outlined"
              sx={{ minWidth: 100 }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmAction}
              size="small"
              variant="contained"
              sx={{ minWidth: 100, paddingY: 0.8 }}
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withRouter(withTranslation()(NeighbourhoodUsers));
